import { render } from "./nav-bar.vue?vue&type=template&id=49fcf619&scoped=true"
import script from "./nav-bar.vue?vue&type=script&lang=ts"
export * from "./nav-bar.vue?vue&type=script&lang=ts"

import "./nav-bar.vue?vue&type=style&index=0&id=49fcf619&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49fcf619"

export default script